import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  right: 140px;
  top: 5px;
`;
Wrapper.displayName = 'Wrapper';

export const dropdownStyle = (theme) => ({
  control: () => ({
    height: '34px',
    width: '171px',
    borderRadius: '1px',
    backgroundColor: theme.selector.background,
    boxShadow: theme.shadows.standardDropdown,
    borderWidth: '1px 0px 0px 1px',
    borderSstyle: 'solid',
    borderColor: `${theme.borders.actionDropDown}`,
    color: theme.selector.text,
    paddingLeft: '10px',
    fontWeight: '700',
    textOverflow: 'ellipsis',
    cursor: 'pointer'
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  placeholder: () => ({
    fontSize: '14px',
    color: theme.selector.text,
    position: 'relative',
    fontWeight: 400
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    position: 'absolute',
    top: '0px',
    right: '4px',
    color: theme.selector.text,
    width: '30px'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? theme.backgrounds.actionDropDownHover : theme.backgrounds.actionDropDown,
    fontSize: '13.5px',
    textAlign: 'left',
    color: theme.text.actionDropDownItem,
    cursor: state.isSelected ? 'default' : 'pointer',
    paddingLeft: '22px',
    paddingRight: '22px',
    textTransform: 'capitalize',
    fontWeight: state.isSelected ? 600 : 300,
    textOverflow: 'unset',
    whiteSpace: 'unset',
    overflow: 'visible'
  }),
  valueContainer: () => ({
    height: '33px',
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px'
  }),
  menu: () => ({
    position: 'absolute',
    marginTop: '6px',
    zIndex: 5000,
    width: '100%',
    border: 'none',
    borderRadius: '3px',
    backgroundColor: theme.backgrounds.actionDropDown,
    boxShadow: `2px 2px 30px 0 ${theme.shadows.actionDropDown}`,
    minWidth: '171px',
    whiteSpace: 'normal',
    overflow: 'auto',
    textOverflow: ''
  }),
  menuList: () => ({
    maxHeight: '250px',
    overflowX: 'auto',
    borderRadius: '3px',
    paddingTop: '17px',
    paddingBottom: '13px'
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    return {
      ...provided, opacity, transition, color: theme.selector.text, width: 'fit-content', height: '19px', fontSize: '13.5px', fontWeight: 400, position: 'relative', maxWidth: 'calc(100% - 24px)'
    };
  }
});
